'use strict';

/**
 * @ngdoc function
 * @name exhibitorPortalApp.controller:SurveyQuestionCtrl
 * @description
 * # Survey Question Ctrl
 * Controller of the exhibitorPortalApp
 */

(function(angular, window, undefined) {
  var SurveyQuestionCtrl = function ($scope, $state, $q, $timeout, $filter, CurrentEvent, Survey, SurveyQuestion, Search, SurveyService, SurveyQuestions, modalFactory, $stateParams, SAVE_STATUS) {
    'ngInject'
		var self = this;

        SurveyQuestion.SurveyAnswers = $filter('orderBy')(SurveyQuestion.SurveyAnswers, 'DisplayOrder');

        for(var i = 0; i < SurveyQuestion.SurveyAnswers.length; i++)
            SurveyQuestion.SurveyAnswers[i].DisplayOrder = i;

        self.survey = Survey;
        self.baseSurveyQuestion = SurveyQuestion;
		    self.surveyQuestion = angular.copy(SurveyQuestion);
		    self.search = Search.surveyQuestion;
        self.search.edit = false;
        self.answersToAdd = '';
        self.hasOther = false;
        self.otherAnswerText = '';
        self.debounce = 3000;
        self.pendingSave = null;
        self.saveStatus = null;
        self.SAVE_STATUS = SAVE_STATUS;
        self.isEdit = $stateParams.surveyQuestionId !== "0";

    self.questions = SurveyQuestions;
    self.availableQuestions = SurveyService.availableBranchedQuestions(self.surveyQuestion, self.questions);

    if (!_.any(self.availableQuestions, function (q) { return q.Text === 'END SURVEY' && !q.Id; })) {
        self.availableQuestions.push({
          Id: 0,
          Text: 'END SURVEY',
          EndSurvey: true
        });
    }

    if (!_.any(self.availableQuestions, function (q) { return q.Text === 'NONE - Remove Branching' && !q.Id; })) {
        self.availableQuestions.push({
          Id: -1,
          Text: 'NONE - Remove Branching',
          EndSurvey: false,
          RemoveBranching: true
        });
      }

    self.changeBranchAction = function (answer) {
        if (answer) {
          if (answer.BranchAction === 'NATURAL') {
            answer.BranchAction = 'OVERRIDE';
          } else {
            answer.BranchAction = 'NATURAL';
            SurveyService.setNextQuestionIdByNaturalOrder(answer, self.surveyQuestion, self.questions);
          }
        }
      };

    self.changeNextQuestion = function (answer) {
        if (!answer)
          return;

        var nextQuestion = self.availableQuestions.filter(function (q) { return q.Id == answer.NextQuestionId; })[0];
        if (nextQuestion && nextQuestion.EndSurvey) {
          answer.BranchAction = 'ENDSURVEY';
        } else if (nextQuestion && nextQuestion.RemoveBranching) {
          answer.BranchAction = 'NATURAL';
          SurveyService.setNextQuestionIdByNaturalOrder(answer, self.surveyQuestion, self.questions);
        } else {
          answer.BranchAction = 'OVERRIDE'; //first question selecting third as branch
        }
      };

    self.changeNextQuestionOther = function () {
        var nextQuestion = self.availableQuestions.filter(function (q) { return q.Id == self.otherNextQuestionId; })[0];
        if (nextQuestion && nextQuestion.EndSurvey) {
          self.otherBranchAction = 'ENDSURVEY';
        } else if (nextQuestion && nextQuestion.RemoveBranching) {
          self.otherBranchAction = 'NATURAL';
          var answer = { BranchAction: 'NATURAL', NextQuestionId: null };
          SurveyService.setNextQuestionIdByNaturalOrder(answer, self.surveyQuestion, self.questions);
          self.otherNextQuestionId = answer.NextQuestionId;
        } else {
          self.otherBranchAction = 'OVERRIDE';
        }
      };

      self.changeBranchActionOther = function () {
        if (self.otherBranchAction === 'NATURAL') {
          self.otherBranchAction = 'OVERRIDE';
        } else {
          self.otherBranchAction = 'NATURAL';
          self.otherNextQuestionId = null;
        }
      };

      self.otherNextQuestionId = null;
      self.otherBranchAction = 'NATURAL';

      var other = self.surveyQuestion.SurveyAnswers.filter(function(x) { return x.SurveyAnswerTypeCode === 'OPN' && x.IsActive; });

        if(other.length){
            self.hasOther = true;
          self.otherAnswerText = other[0].Text;
          self.otherNextQuestionId = other[0].NextQuestionId;
          self.otherBranchAction = other[0].BranchAction;
        }

        const confirmUnsavedChanges = function(e) {
            if(!angular.equals(self.surveyQuestion, self.baseSurveyQuestion)) {
                if(!window.confirm('You have unsaved changes that will be lost, are you sure you want to proceed?')){
                  e.preventDefault();
                }else if(self.pendingSave) {
                  $timeout.cancel(self.pendingSave);
                }
            }
        };

        $scope.$on('$stateChangeStart', confirmUnsavedChanges);
        $scope.$on('beforeLeave', confirmUnsavedChanges);

        if(!window._saveOnlineAgain) {
          window._saveOnlineAgain = function (e) {
            self.autoSave(true);
          }
          window.addEventListener('online', window._saveOnlineAgain);
        }
        
        if (!window._surveyQuestionBeforeUnload) {
            window._surveyQuestionBeforeUnload = function(e) {
                if(!angular.equals(self.surveyQuestion, self.baseSurveyQuestion)) {
                    e.preventDefault();
                    e.returnValue = '';
                }else if(self.pendingSave) {
                  $timeout.cancel(self.pendingSave);
                }
            };
            window.addEventListener('beforeunload', window._surveyQuestionBeforeUnload);
        }

        $scope.$on('$destroy', function() {
            if (window._surveyQuestionBeforeUnload) {
                window.removeEventListener('beforeunload', window._surveyQuestionBeforeUnload);
                window._surveyQuestionBeforeUnload = null;
            }
            if(window._saveOnlineAgain) {
              window.removeEventListener('online', window._saveOnlineAgain);
              window._saveOnlineAgain = null;
            }
        });

      self.changePriority = function (priority) {
        self.prevPriority = self.surveyQuestion.Priority;
        self.surveyQuestion.Priority = priority;
        self.autoSave();
      };

        self.answerFilter = function(answer) {
            return answer.SurveyAnswerTypeCode !== 'OPN';
        };

        self.addAnswer = function() {
            //split on new line and remove empty entries
            var answers = self.answersToAdd.split('\n').filter(function(x) { return x.trim(); });

            for(var i = 0; i < answers.length; i++){
                self.surveyQuestion.SurveyAnswers.push({
                    Id: 0,
                    SurveyQuestionId: self.surveyQuestion.Id,
                    SurveyAnswerTypeCode: 'SEL',
                    Text: answers[i],
                    IsActive: true,
                    DisplayOrder: self.surveyQuestion.SurveyAnswers.length + 1
                });
            };

            self.answersToAdd = '';
        };

        self.hasActiveAnswers = function() {
          if (!self.surveyQuestion.SurveyAnswers)
            return false;

          return self.surveyQuestion.SurveyAnswers.find(answer => answer.SurveyAnswerTypeCode !== 'OPN' && answer.IsActive) ? true : false;
        };

        $scope.$watch(function () {
          return self.surveyQuestion.Text;
        }, function (newval, oldval) {
          if (newval !== oldval) {
            if (!self.surveyQuestion.Id && _.any(self.survey.SurveyQuestions, function (sq) { return sq.Text === newval; }))
              self.form.questionName.$setValidity('nonunique', false);
            else
              self.form.questionName.$setValidity('nonunique', true);
          }
        });

    self.save = function (redirect) {
            if(!self.form.$valid){
                var d = $q.defer();

                $timeout(function() {
                    self.form.$setSubmitted();

                    d.reject();
                });

                return d.promise;
            }

            if(self.answersToAdd.trim())
                self.addAnswer();

            if(other.length){
              if (self.hasOther) {
                other[0].Text = self.otherAnswerText || other[0].Text;
                other[0].NextQuestionId = self.otherNextQuestionId;
                other[0].BranchAction = self.otherBranchAction;
              }
                else
                    other[0].IsActive = false;
            }
            else if(!other.length && self.hasOther){
                var newOther = {
                    Id: 0,
                    SurveyQuestionId: self.surveyQuestion.Id,
                    SurveyAnswerTypeCode: 'OPN',
                    Text: self.otherAnswerText,
                    IsActive: true,
                    DisplayOrder: self.surveyQuestion.SurveyAnswers.length + 1,
                    NextQuestionId: self.otherNextQuestionId,
                    BranchAction: self.otherBranchAction
                };
                other.push(newOther);
                self.surveyQuestion.SurveyAnswers.push(newOther);
            }

            if (!angular.equals(self.surveyQuestion, self.baseSurveyQuestion)) {

                if (!self.surveyQuestion.Id && !_.any(self.survey.SurveyQuestions, function (sq) { return sq.Text === self.surveyQuestion.Text; }))
                    self.survey.SurveyQuestions.push(self.surveyQuestion);
                else
                    for(var i = 0; i < self.survey.SurveyQuestions.length; i++)
                        if(self.survey.SurveyQuestions[i].Id == self.surveyQuestion.Id){
                          self.survey.SurveyQuestions[i] = self.surveyQuestion;
                            break;
                        }

                return SurveyService
                    .saveSurvey({
                        params: { showCode: CurrentEvent.ShowCode },
                        data: {
                            showCode: CurrentEvent.ShowCode,
                            survey: self.survey
                        }
                    })
                  .then(function(survey) {
                        for(var i = 0; i < SurveyService.data.surveys[CurrentEvent.ShowCode].length; i++){
                            if(SurveyService.data.surveys[CurrentEvent.ShowCode][i].Id == survey.Id){
                                //edit case
                                if(self.surveyQuestion.Id){
                                    for(var a = 0; a < SurveyService.data.surveys[CurrentEvent.ShowCode][i].SurveyQuestions.length; a++)
                                        if(SurveyService.data.surveys[CurrentEvent.ShowCode][i].SurveyQuestions[a].Id == self.surveyQuestion.Id){
                                            self.baseSurveyQuestion = SurveyService.data.surveys[CurrentEvent.ShowCode][i].SurveyQuestions[a];
                                            self.surveyQuestion = angular.copy(self.baseSurveyQuestion);
                                            break;
                                        }
                                }
                                //add case
                                else {
                                    //determine which question is the new one by comparing old question array to new
                                    for(var a = 0; a < SurveyService.data.surveys[CurrentEvent.ShowCode][i].SurveyQuestions.length; a++){
                                        var existingQuestion = self.survey.SurveyQuestions.filter(function(x) {
                                            return x.Id == SurveyService.data.surveys[CurrentEvent.ShowCode][i].SurveyQuestions[a].Id;
                                        });

                                        if(!existingQuestion.length){
                                            //find the old question object and update it with its new Id and any saved answer objects
                                            var unsavedQuestion = self.survey.SurveyQuestions.filter(function(x) { return !x.Id; });

                                            if(unsavedQuestion.length){
                                                unsavedQuestion[0] = SurveyService.data.surveys[CurrentEvent.ShowCode][i].SurveyQuestions[a];
                                                self.baseSurveyQuestion = unsavedQuestion[0];
                                                self.surveyQuestion = angular.copy(self.baseSurveyQuestion);
                                                break;
                                            }
                                        }
                                    }
                                }

                                break;
                            }
                        }

                        if(redirect !== false)
                            $state.go('event.surveys.survey', { id: self.survey.Id });
                    });
            }
            else {
                var d = $q.defer();

                $timeout(function() {
                    d.resolve();

                    if(redirect !== false)
                        $state.go('event.surveys.survey', { id: self.survey.Id });
                });

                return d.promise;
            }
        };

        self.autoSave = function (skipDebounce ) {
          if(!self.isEdit) return;
          if(self.pendingSave) {
            $timeout.cancel(self.pendingSave);
          }
          self.pendingSave = $timeout(function () {
              self.saveStatus = SAVE_STATUS.SAVING;
              self.save(false).then(function () {
                self.saveStatus = SAVE_STATUS.SAVED;
                $timeout(function () {
                  self.saveStatus = SAVE_STATUS.FADEOUT_SAVED;
                  $timeout(function () {
                    self.saveStatus = null;
                  }, 300);
                }, 5000);
              }).catch(function () {
                self.saveStatus = SAVE_STATUS.ERROR;
                $timeout(function () {
                  self.saveStatus = SAVE_STATUS.FADEOUT_ERROR;
                  $timeout(function () {
                    self.saveStatus = null;
                  }, 300);
                }, 5000);
              });
          }, skipDebounce ? 1 : self.debounce);
        }

        self.changeType = function(type) {
            self.surveyQuestion.SurveyQuestionTypeCode = type;
            self.autoSave();
        };

        self.upClick = function(index) {
            if(index === 0)
                self.paginated[index].DisplayOrder = self.paginated[self.paginated.length - 1].DisplayOrder + 1;
            else {
                var dest, destDisplayOrder;

                dest = self.paginated[index - 1];
                destDisplayOrder = dest.DisplayOrder;

                dest.DisplayOrder = self.paginated[index].DisplayOrder;
                self.paginated[index].DisplayOrder = destDisplayOrder;
            }
        };

        self.downClick = function(index) {
            if(index === self.paginated.length - 1){
                self.paginated[index].DisplayOrder = 0;

                for(var i = 0; i < self.paginated.length; i++)
                    if(self.paginated[i] != self.paginated[index])
                        self.paginated[i].DisplayOrder++;
            }
            else {
                var dest, destDisplayOrder;

                dest = self.paginated[index + 1];
                destDisplayOrder = dest.DisplayOrder;

                dest.DisplayOrder = self.paginated[index].DisplayOrder;
                self.paginated[index].DisplayOrder = destDisplayOrder;
            }
        };

        self.edit = function(e) {
            self.search.edit = !self.search.edit;
            e.target.value = self.search.edit;
            angular.element(e.target).triggerHandler('change', true);
        };

        self.activePredicate = function(active, edit) {
            if(edit === 'true')
                return true;
            else
                return active;
        };

        self.preview = function() {
            return self.save(false).then(function () {
            var previewData = {
              name: self.survey.Name,
              questions: self.survey.SurveyQuestions.filter(function(q) { return q.IsActive; }).map(function(q) {
                return angular.extend({}, q, {
                  SurveyAnswers: q.SurveyAnswers.filter(function(a) { return a.IsActive; })
                });
              })
            };

            modalFactory.showModal({
              bodyTemplateUrl: 'views/shared/surveyPreviewModal.html',
              controller: 'SurveyPreviewModalCtrl',
              modalcss: 'small',
              inputs: {
                previewData: previewData,
                title: previewData.name
              }
            });
          });
        };
	};

	angular.module('exhibitorPortalApp')
	  .constant('SAVE_STATUS', {
	    SAVING: 'saving',
	    SAVED: 'saved',
	    ERROR: 'error',
	    FADEOUT_SAVED: 'fadeout-saved',
	    FADEOUT_ERROR: 'fadeout-error'
	  })
	  .controller('SurveyQuestionCtrl', SurveyQuestionCtrl);
})(angular, window);
